import React from 'react';

import moment from 'moment';

import { Size, Theme } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { UserBlock } from '@lumapps/user/components/UserBlock';
import { BlockComponent } from '@lumapps/widget-base/types';

import { BlockResourceCreationInfo as BlockResourceCreationInfoProps } from '../../type';

/**
 * The number of days to display the date of the post as a "from now" string (e.g. "1 hour ago").
 * Above this number of days, the date of the post will be displayed as a plain date.
 *
 * @type {number}
 * @constant
 * @readonly
 */
const DELTA_DAY_FROM_NOW = 1;

/**
 * Component to render author's informations in a post.
 * Display current community if has communityName props
 * Display categories if an array of tags is given
 */
export const BlockResourceCreationInfo: BlockComponent<BlockResourceCreationInfoProps> = ({
    author,
    createdAt,
    theme = Theme.light,
}) => {
    const { translateKey } = useTranslate();

    let displayedPublicationDate;
    if (createdAt) {
        displayedPublicationDate =
            moment().diff(moment(createdAt), 'days') < DELTA_DAY_FROM_NOW
                ? moment.utc(createdAt).local().fromNow()
                : moment.utc(createdAt).local().format('LL');
    } else {
        displayedPublicationDate = translateKey(GLOBAL.RIGHT_NOW);
    }

    return (
        <UserBlock
            user={{
                ...author,
                id: author.userId,
            }}
            size={Size.m}
            additionalFields={[displayedPublicationDate]}
            fields={[]}
            theme={theme}
            scope="block-resource-creation-info"
        />
    );
};
